import Layout from "../../components/Layout/Layout";
import React, { useEffect, useState, Fragment, useRef } from 'react'
import { SearchIcon, QuestionMarkCircleIcon } from '@heroicons/react/solid';
import { DocumentDownloadIcon, DotsHorizontalIcon, MailOpenIcon } from "@heroicons/react/outline";
import ChequeServices from './../../services/ChequeServices';
import { convert, formatDate } from './../../utils/convertDate';
import Paginate from "../../utils/Paginate";
import { Menu, Transition, Dialog } from '@headlessui/react'
import fire from './../../utils/Toastr';
import DatePicker from 'react-date-picker';


const statusStyles = {
  Treated: 'bg-green-500 text-white',
  Untreated: 'bg-orange-600 text-white',
  Pending: 'bg-amber-400 text-white',
  Primary_Approved:'bg-orange-600 text-white'
}
function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function ChequeBook() {
  const errors = {
    commentError: "",
    commentIsValidated: "",
    formIsSubmitting: false
  }

  const [cheq, setCheque] = useState([])
  const [search, setSearch] = useState("")
  const [pageIndex, setPageIndex] = useState(1);
  const [prevPage, setPrev] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalPage, setPage] = useState(0)
  const [nextPage, setNextPage] = useState(false);
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [status, setStatus] = useState("");
  const [type, setType] = useState("");
  const [pageLength, setPageLength] = useState("");
  const oldFrom = new Date().setDate(new Date().getDate() - 7);
  const [formValues, setFormValues] = useState({
    from: new Date(oldFrom),
    to: new Date()
  })
  const defaultTo = formatDate(new Date());
  const longNew = formatDate(defaultTo);
  const [too, setToo] = useState(convert(longNew));
  const defaultFrom = formatDate(new Date().setDate(new Date().getDate() - 7))
  const longDate = formatDate(defaultFrom);
  const [fromm, setFromm] = useState(convert(longDate));
  const [summ, setSummary] = useState({});
  const [open, setOpen] = useState(false);
  const [openReject, setRejectOpen] = useState(false);
  const cancelButtonRef = useRef(null);
  const [commentValue, setCommentValue] = useState({
    comment: ""
  });
  const [formState, setFormState] = useState(errors);
  const [approveId, setApproveId] = useState({});
  const [rejectId, setRejectId] = useState({});
  const [chequesStatus, setChequeStatus] = useState("")
  const [primMail, setPrimMail] = useState(false);
  const [secMail, setSecMail] = useState(false)

  const list = async () => {
    const resp = await ChequeServices.listChequeBook(pageIndex, 10, search, fromm, too, status, type);
    setCheque([...resp.data.result])
    setPageLength([...resp.data.result].length);
    setPageNumber(resp.data.totalCount)
    setPageIndex(resp.data.pageIndex)
    setPrev(resp.data.hasPreviousPage);
    setPage(resp.data.totalPages)
    setNextPage(resp.data.hasNextPage);
    const sum = await ChequeServices.summary();
    setSummary(sum.data)
  }
  const handleType = async (text) => {
    if (text === "All") {
      const resp = await ChequeServices.listChequeBook(pageIndex, 10, search, fromm, too, status, type);
      setCheque([...resp.data.result]);
      setPageLength([...resp.data.result].length);
      setPageNumber(resp.data.totalCount)
      setPageIndex(resp.data.pageIndex)
      setPrev(resp.data.hasPreviousPage);
      setPage(resp.data.totalPages)
      setNextPage(resp.data.hasNextPage)
    } else {
      setType(text);
      const resp = await ChequeServices.listChequeBook(pageIndex, 10, search, fromm, too, status, text);
      setCheque([...resp.data.result]);
      setPageLength([...resp.data.result].length);
      setPageNumber(resp.data.totalCount)
      setPageIndex(resp.data.pageIndex)
      setPrev(resp.data.hasPreviousPage);
      setPage(resp.data.totalPages)
      setNextPage(resp.data.hasNextPage)
    }

  }
  const handleStatus = async (text) => {

    if (text === "All") {
      const resp = await ChequeServices.listChequeBook(pageIndex, 10, search, fromm, too, status, type);
      setCheque([...resp.data.result]);
      setPageLength([...resp.data.result].length);
      setPageNumber(resp.data.totalCount)
      setPageIndex(resp.data.pageIndex)
      setPrev(resp.data.hasPreviousPage);
      setPage(resp.data.totalPages)
      setNextPage(resp.data.hasNextPage)
    } else {
      setStatus(text);
      const resp = await ChequeServices.listChequeBook(pageIndex, 10, search, fromm, too, text, type);
      setCheque([...resp.data.result]);
      setPageLength([...resp.data.result].length);
      setPageNumber(resp.data.totalCount)
      setPageIndex(resp.data.pageIndex)
      setPrev(resp.data.hasPreviousPage);
      setPage(resp.data.totalPages)
      setNextPage(resp.data.hasNextPage)
    }

  }


  const range = async (e) => {
    e.preventDefault();
    const newDate = formatDate(formValues.from)
    setFrom(formValues.from)
    var longDate = formatDate(newDate);
    setFromm(convert(longDate));

    const toDate = formatDate(formValues.to);
    setTo(formValues.to)
    setToo(convert(toDate));

    const resp = await ChequeServices.listChequeBook(pageIndex, 10, search, convert(newDate), convert(toDate), status, type);
    setCheque([...resp.data.result]);
    setPageLength([...resp.data.result].length);
    setPageNumber(resp.data.totalCount);
    setPageIndex(resp.data.pageIndex)
    setPrev(resp.data.hasPreviousPage);
    setPage(resp.data.totalPages)
    setNextPage(resp.data.hasNextPage)
  }
  const dateValidation = {
    fromHandler: (event) => {
      setFormValues({ ...formValues, from: event })
    },
    toHandler: (event) => {
      setFormValues({ ...formValues, to: event })
    }
  };
  const searchCheque = async (text) => {
      setSearch(text);
  }

  // primary mailing list and secondary approval
  const approve = async () => {
    if (primMail && chequesStatus.toLowerCase() === "pending") {
      const resp = await ChequeServices.actionChequeRequest({ id: approveId, chequeStatus: "Primary_Approved", comment: commentValue.comment })
      if (resp) {
        fire("success", resp.message);
        setTimeout(() => {
          window.location.reload();
        }, 4000);
      }
     
    } else if (secMail && chequesStatus.toLowerCase() === "primary_approved") {
      const resp = await ChequeServices.actionSecChequeRequest({ id: approveId, chequeStatus: "Approved", comment: commentValue.comment })
      if (resp) {
        fire("success", resp.message);
        setTimeout(() => {
          window.location.reload();
        }, 4000);
      }
    
    }
  }
  //Primary reject
  const reject = async () => {
    if (primMail && chequesStatus.toLowerCase() === "pending") {
      const resp = await ChequeServices.actionChequeRequest({ id: rejectId, chequeStatus: "Rejected", comment: commentValue.comment })
      if (resp) {
        fire("success", resp.message);
      setTimeout(() => {
        window.location.reload();
      }, 4000);
      }
     
    } else if (secMail && chequesStatus.toLowerCase() === "primary_approved") {
      const resp = await ChequeServices.actionSecChequeRequest({ id: rejectId, chequeStatus: "Rejected", comment: commentValue.comment })
      if (resp) {
        fire("success", resp.message);
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      }
     
    }

  }



  const exportCSV = async () => {
    const resp = await ChequeServices.exportChequeRequest(search, fromm, too, status, type);
    window.open(resp.data)
  }

  // comments Modal
  const handleApprove = async (person) => {
    setOpen(true);
    setApproveId(person.id);
    setChequeStatus(person.chequeBookStatus)
  }
  const handleReject = async (person) => {
    setRejectOpen(true);
    setRejectId(person.id);
    setChequeStatus(person.chequeBookStatus)
  }
  const handleClose = () => {
    setOpen(false);

  }
  const handleRejectClose = () => {
    setRejectOpen(false);
  }

  // comment validation
  const formHandler = {
    commentHandler: (event) => {
      setCommentValue({ ...commentValue, comment: event.target.value });
      if (event.target.value.trim().length < 1) {
        setFormState({
          ...formState,
          commentError: "Comment cannot be empty",
          commentIsValidated: false,
        });
        return;
      }

      setFormState({
        ...formState,
        commentError: "",
        commentIsValidated: true
      })
    },
  }
  const getMod = async () => {
    var Mod = JSON.parse(sessionStorage.getItem("user"));
    const me = Mod.primaryModules.find((x => x === "cheques"));
    if (me === "cheques") {
      setPrimMail(true);
    }
    const sec = Mod.secondaryModules.find((x => x === "cheques"));
    if (sec === "cheques") {
      setSecMail(true);
    }

  }
  useEffect(() => {
    list();
    getMod();
  }, [pageIndex])
  return (
  <Layout title={'Chequebook Requests'} pageTag={'cheque'} current={'/request/cheque'}>
    <React.Fragment>
      <main>
        <div className='max-w-7xl mx-auto px-4 sm:px-6 md:px-8'>
          <dl className="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 mb-5">

            <div className="relative flex bg-white pt-5 px-4 pb-5 sm:pt-6 sm:px-6 shadow rounded-lg overflow-hidden">
              <div className="absolute  rounded-md p-3">
                <MailOpenIcon className="h-6 w-6 text-gray-900" aria-hidden="true" />
              </div>
              <div>
                <p className="ml-12 text-sm font-medium text-gray-500 truncate">Total Approved Request</p>
                <p className="text-2xl ml-12 font-semibold text-gray-900">{summ.totalApprovedChequeBookRequest}</p>
              </div>
            </div>
            <div className="relative flex bg-white pt-5 px-4 pb-5 sm:pt-6 sm:px-6 shadow rounded-lg overflow-hidden">
              <div className="absolute  rounded-md p-3">
                <MailOpenIcon className="h-6 w-6 text-gray-900" aria-hidden="true" />
              </div>
              <div>
                <p className="ml-12 text-sm font-medium text-gray-500 truncate">Total Rejected Request</p>
                <p className="text-2xl ml-12 font-semibold text-gray-900">{summ.totalRejectedChequeBookRequest}</p>
              </div>
            </div>
            <div className="relative flex bg-white pt-5 px-4 pb-5 sm:pt-6 sm:px-6 shadow rounded-lg overflow-hidden">
              <div className="absolute  rounded-md p-3">
                <MailOpenIcon className="h-6 w-6 text-gray-900" aria-hidden="true" />
              </div>
              <div>
                <p className="ml-12 text-sm font-medium text-gray-500 truncate">Total Pending Request</p>
                <p className="text-2xl ml-12 font-semibold text-gray-900">{summ.totalPendingChequeBookRequest}</p>
              </div>
            </div>
          </dl>
          <div className="mt-4 sm:mt-0 sm:ml-6  flex justify-end">
            <button
              type="button"
              onClick={exportCSV}
              className="hover:text-white active:text-white inline-flex mr-2 items-center justify-center rounded-md border border-transparent btn-green px-2 py-2 text-sm font-medium text-green shadow-sm sm:w-auto"
            >
              <DocumentDownloadIcon className="w-4 mr-1.5" />
              Export CSV
            </button>
          </div>
          <div className="sm:flex sm:items-center ml-4">
              <div className="sm:flex-auto flex">
              
              
                <div className=" relative rounded-md shadow-sm ml-3">
                  <p className='text-sm leading-3 text-gray-500'>From</p>
                  <div>
                    <DatePicker onChange={dateValidation.fromHandler} value={formValues.from} />
                  </div>
                </div>
                <div className=" relative rounded-md shadow-sm ml-3">
                  <p className='text-sm leading-3 text-gray-500'>To</p>
                  <div>
                    <DatePicker onChange={dateValidation.toHandler} value={formValues.to} />
                  </div>
                </div>
                <div className="flex ml-4">
                  <div className="mt-5 relative rounded-md shadow-sm">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      <SearchIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                    </div>
                    <input
                      type="text"
                      name="user"
                      id="user"
                      onChange={(e) => searchCheque(e.target.value)}
                      className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md"
                      placeholder="Search "
                    />
                    <div className=" absolute inset-y-0 right-0 flex items-center pr-3">
                      <div className='tooltip'>
                        <QuestionMarkCircleIcon className="w-4 mr-1.5 text-gray-400" />
                        <span className="tooltiptext"> <p>Search by account number, residential address and first name</p></span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='mt-5 ml-4'>
                  <button
                    onClick={range}
                    className='hover:text-white active:text-white inline-flex mr-2 items-center justify-center rounded-md border border-transparent btn-green px-6 py-2 text-sm font-medium text-green shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto'>Search</button>
                </div>
                <div className="mt-5 relative rounded-md shadow-sm ml-3">
                  <select
                    id="currency"
                    name="currency"
                    onChange={(e) => handleType(e.target.value)}
                    placeholder="Sort by"
                    className="focus:ring-indigo-500 focus:border-indigo-500 h-full py-0 pl-2 pr-7 border-gray-300 bg-transparent text-gray-500 sm:text-sm rounded-md"
                  >
                    <option>Sort by</option>
                    <option value={"All"}>All</option>
                    <option value={"Pickup"}>Pickup</option>
                    <option value={"HomeDelivery"}>Home Delivery</option>
                  </select>
                </div>
                <div className="mt-5 relative rounded-md shadow-sm ml-3">
                  <select
                    id="currency"
                    name="currency"
                    onChange={(e) => handleStatus(e.target.value)}
                    placeholder="Filter by"
                    className="focus:ring-indigo-500 focus:border-indigo-500 h-full py-0 pl-2 pr-7 border-gray-300 bg-transparent text-gray-500 sm:text-sm rounded-md"
                  >
                    <option>Filter by</option>
                    <option value={"All"}>All</option>
                    <option value={"Pending"}>Pending</option>
                    <option value={"Approved"}>Approved</option>
                    <option value={"Rejected"}>Rejected</option>
                    <option value={"Expired"}>Expired</option>
                  </select>
                </div>
              </div>
              <div className=" relative rounded-md shadow-sm ml-3">
                <p className='text-sm leading-3 text-gray-500'>To</p>
                <div>
                  <DatePicker onChange={dateValidation.toHandler} value={formValues.to} />
                </div>
              </div>
              <div className="flex">
                <div className="mt-5 ml-4 relative rounded-md shadow-sm">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <SearchIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                  </div>
                  <input
                    type="text"
                    name="user"
                    id="user"
                    onChange={(e) => searchCheque(e.target.value)}
                    className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md"
                    placeholder="Search request"
                  />
                  <div className=" absolute inset-y-0 right-0 flex items-center pr-3">
                    <div className='tooltip'>
                      <QuestionMarkCircleIcon className="w-4 mr-1.5 text-gray-400" />
                      <span className="tooltiptext"> <p>Search by account number, residential address and first name</p></span>
                    </div>
                  </div>
                </div>
              </div>
              <div className='mt-5 ml-4'>
                <button
                  onClick={range}
                  className='hover:text-white active:text-white inline-flex mr-2 items-center justify-center rounded-md border border-transparent btn-green px-6 py-2 text-sm font-medium text-green shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto'>Search</button>
              </div>
              <div className="mt-5 relative rounded-md shadow-sm ml-3">
                <select
                  id="currency"
                  name="currency"
                  onChange={(e) => handleType(e.target.value)}
                  placeholder="Sort by"
                  className="focus:ring-indigo-500 focus:border-indigo-500 h-full py-0 pl-2 pr-7 border-gray-300 bg-transparent text-gray-500 sm:text-sm rounded-md"
                >
                  <option value={"All"}>Sort by</option>
                  <option value={"All"}>All</option>
                  <option value={"Pickup"}>Pickup</option>
                  <option value={"HomeDelivery"}>Home Delivery</option>
                </select>
              </div>
              <div className="mt-5 relative rounded-md shadow-sm ml-3">
                <select
                  id="currency"
                  name="currency"
                  onChange={(e) => handleStatus(e.target.value)}
                  placeholder="Filter by"
                  className="focus:ring-indigo-500 focus:border-indigo-500 h-full py-0 pl-2 pr-7 border-gray-300 bg-transparent text-gray-500 sm:text-sm rounded-md"
                >
                  <option value={"All"}>Filter by</option>
                  <option value={"All"}>All</option>
                  <option value={"Pending"}>Pending</option>
                  <option value={"Approved"}>Approved</option>
                  <option value={"Rejected"}>Rejected</option>
                  <option value={"Expired"}>Expired</option>
                </select>
              </div>
            </div>
          </div>
          {cheq.length === 0 ? (
            <div className=" mt-8"> No data available for these dates to show. </div>
          ) : 
          <>
          <div className="px-4 ">
            <div className="mt-8 flex flex-col">
              <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                  <div className="relative overflow-hidden ring-1 ring-black ring-opacity-5 md:rounded-lg">

                    <table className="min-w-full table-fixed divide-y divide-gray-300 mb-32">
                      <thead>
                        <tr>
                          <th scope="col" className="min-w-[12rem] py-3.5 pr-3 italic font-normal text-left text-sm  text-gray-900">
                            Customer First Name
                          </th>
                          <th scope="col" className="min-w-[12rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                            Customer Last Name
                          </th>
                          <th scope="col" className="min-w-[10rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                            Account Number
                          </th>
                          <th scope="col" className="min-w-[12rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                            Number of Cheque Books
                          </th>
                          <th scope="col" className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                            Delivery Type
                          </th>
                          <th scope="col" className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                            Branch Name
                          </th>
                          <th scope="col" className="min-w-[10rem]  px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                            State of Residence
                          </th>
                          <th scope="col" className="min-w-[12rem]  px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                            Residential Address
                          </th>
                          <th scope="col" className="min-w-[12rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                            Cheque Book Status
                          </th>
                          <th scope="col" className="min-w-[12rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                            Number of Cheque leaves
                          </th>
                          <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                            Request Date
                          </th>
                          <th>

                          </th>
                          <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                            <span className="sr-only">Edit</span>
                          </th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-gray-200 bg-white">
                        {cheq.map((person, i) => (
                          <tr key={i} className="bg-gray-50">
                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{person.customerFirstName}</td>
                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{person.customerLastName}</td>
                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{person.accountNumber}</td>
                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{person.noofChequeBooks}</td>
                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{person.deliveryType}</td>
                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{person.branchName}</td>
                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{person.stateOfResidence === "null" ? 'N/A' : person.stateOfResidence}</td>
                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{person.residentialAddress === "null" ? 'N/A' : person.residentialAddress}</td>
                            <td><span className={classNames(
                              statusStyles[person.chequeBookStatus], "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium text-gray-900")}> {person.chequeBookStatus}</span>
                            </td>
                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{person.noOfLeaves}</td>
                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{formatDate(person.dateCreated)}</td>
                            {!primMail || !secMail ? "" :
                              <td className="whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                                <Menu as="div" className="ml-3  flex-shrink-0">
                                  <div>
                                    <Menu.Button className="  flex text-sm text-white">
                                      <span className="sr-only">Open user menu</span>
                                      <DotsHorizontalIcon className='w-8 text-gray-400' />
                                    </Menu.Button>
                                  </div>
                                  <Transition
                                    as={Fragment}
                                    enter="transition ease-out duration-100"
                                    enterFrom="transform opacity-0 scale-95"
                                    enterTo="transform opacity-100 scale-100"
                                    leave="transition ease-in duration-75"
                                    leaveFrom="transform opacity-100 scale-100"
                                    leaveTo="transform opacity-0 scale-95"
                                  >
                                    <Menu.Items className="origin-top-right absolute right-6 mt-2 w-40 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                                      <button
                                        onClick={() => handleApprove(person)}
                                        value={person.id}
                                        className="block py-2 px-5 text-sm text-gray-700 text-left">
                                        Approve
                                      </button>
                                      <button
                                        onClick={() => handleReject(person)}
                                        className="block py-2 px-5 text-sm text-gray-700 text-left">
                                        Reject
                                      </button>

                                    </Menu.Items>
                                  </Transition>
                                </Menu>

                              </td>
                            }

                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <Transition.Root show={open} as={Fragment}>
              <Dialog as="div" className="relative z-10" initialFocus={cancelButtonRef} onClose={handleClose}>
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0"
                  enterTo="opacity-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100"
                  leaveTo="opacity-0"
                >
                  <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                </Transition.Child>

                <div className="fixed z-10 inset-0 overflow-y-auto">
                  <div className="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
                    <Transition.Child
                      as={Fragment}
                      enter="ease-out duration-300"
                      enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                      enterTo="opacity-100 translate-y-0 sm:scale-100"
                      leave="ease-in duration-200"
                      leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                      leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    >
                      <Dialog.Panel className="relative bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-xs sm:w-full sm:p-6">
                        <div>
                          <div className="mt-3 text-center sm:mt-5">
                            <Dialog.Title as="h3" className="text-lg leading-6 font-medium text-gray-900">
                              Hey, wait!!
                            </Dialog.Title>
                            <div className="mt-2">
                              <p className="text-sm text-gray-500">
                                Are you sure you want  approve this request?
                              </p>
                              <form>
                                <label htmlFor="comment" className="text-left mt-2 block text-sm font-medium text-gray-700">Comment</label>
                                <div className="mt-1">
                                  <input
                                    id="comment"
                                    name="comment"
                                    type="text"
                                    placeholder='Enter comment'
                                    autoComplete="text"
                                    value={commentValue.comment}
                                    onChange={formHandler.commentHandler}
                                    required
                                    className="appearance-none block w-full pb-4 pt-4 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  />
                                  {!formState.commentIsValidated && formState.commentError && (
                                    <div className="text-red-800">
                                      {formState.commentError}
                                    </div>
                                  )}
                                </div>
                              </form>
                            </div>
                          </div>
                        </div>
                        <div className="mt-5 sm:mt-6 sm:flex sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                          <button
                            type="button"
                            className="w-full inline-flex justify-center rounded-md border border-gray-900 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-900  sm:col-start-2 sm:text-sm"
                            onClick={(text) => approve(text)}
                          >
                            Yes, I do
                          </button>
                          <button
                            type="button"
                            className="mt-3 w-full inline-flex justify-center rounded-md border bg-dark border-gray-300 shadow-sm px-4 py-2  text-base font-medium text-white btn-primary sm:mt-0 sm:col-start-1 sm:text-sm"
                            onClick={() => setOpen(false)}

                            ref={cancelButtonRef}
                          >
                            No, I dont
                          </button>
                        </div>
                      </Dialog.Panel>
                    </Transition.Child>
                  </div>
                </div>
              </Dialog>
            </Transition.Root>
            <Transition.Root show={openReject} as={Fragment}>
              <Dialog as="div" className="relative z-10" initialFocus={cancelButtonRef} onClose={handleRejectClose}>
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0"
                  enterTo="opacity-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100"
                  leaveTo="opacity-0"
                >
                  <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                </Transition.Child>

                <div className="fixed z-10 inset-0 overflow-y-auto">
                  <div className="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
                    <Transition.Child
                      as={Fragment}
                      enter="ease-out duration-300"
                      enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                      enterTo="opacity-100 translate-y-0 sm:scale-100"
                      leave="ease-in duration-200"
                      leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                      leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    >
                      <Dialog.Panel className="relative bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-xs sm:w-full sm:p-6">
                        <div>
                          <div className="mt-3 text-center sm:mt-5">
                            <Dialog.Title as="h3" className="text-lg leading-6 font-medium text-gray-900">
                              Hey, wait!!
                            </Dialog.Title>
                            <div className="mt-2">
                              <p className="text-sm text-gray-500">
                                Are you sure you want reject this request?
                              </p>
                              <form>
                                <label htmlFor="comment" className="text-left mt-2 block text-sm font-medium text-gray-700">Comment</label>
                                <div className="mt-1">
                                  <input
                                    id="comment"
                                    name="comment"
                                    type="text"
                                    placeholder='Enter comment'
                                    autoComplete="text"
                                    value={commentValue.comment}
                                    onChange={formHandler.commentHandler}
                                    required
                                    className="appearance-none block w-full pb-4 pt-4 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  />
                                  {!formState.commentIsValidated && formState.commentError && (
                                    <div className="text-red-800">
                                      {formState.commentError}
                                    </div>
                                  )}
                                </div>
                              </form>
                            </div>
                          </div>
                        </div>
                        <div className="mt-5 sm:mt-6 sm:flex sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                          <button
                            type="button"
                            className="w-full inline-flex justify-center rounded-md border border-gray-900 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-900  sm:col-start-2 sm:text-sm"
                            onClick={() => reject()}
                          >
                            Yes, I do
                          </button>
                          <button
                            type="button"
                            className="mt-3 w-full inline-flex justify-center rounded-md border bg-dark border-gray-300 shadow-sm px-4 py-2  text-base font-medium text-white btn-primary sm:mt-0 sm:col-start-1 sm:text-sm"
                            onClick={() => setRejectOpen(false)}
                            ref={cancelButtonRef}
                          >
                            No, I dont
                          </button>
                        </div>
                      </Dialog.Panel>
                    </Transition.Child>
                  </div>
                </div>
              </Dialog>
            </Transition.Root>
            <Paginate
                                    nextPage={nextPage}
                                    pageIndex={pageIndex}
                                    totalCount={pageNumber}
                                    totalPages={totalPage}
                                    prevPage={prevPage}
                                    setPageIndex={setPageIndex}
                                />
          </div>
        </>}
         

      </main>
    </React.Fragment>
  </Layout>
  )
  
}